module.exports = __webpack_public_path__ + "img/m_custmobg.33d200db.jpg";